import { memo, useId, useMemo } from "react";

import { QuestionMinAndMaxNum } from "@/components/features/items/edit/plan/_shared/ui/components/min-and-max-people-num/min-and-max-num";
import { QuestionMinAndMaxPeopleNumPerRoom } from "@/components/features/items/edit/plan/_shared/ui/components/min-and-max-people-num/min-and-max-people-num-per-room";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion/accordion";

import { usePlanMinAndMaxPeopleNumPerRoom, usePlanMinAndMaxRoomNum } from "./hooks";

export const QuestionPlanMinAndMaxPeopleNum = memo(() => {
	const uniqueId = useId();
	const { maxPeopleNumPerRoom, onSetMaxPeopleNumPerRoom, minimumPeopleNumPerRoom, onSetMinimumPeopleNumPerRoom } =
		usePlanMinAndMaxPeopleNumPerRoom();

	const { maxRoomNum, minRoomNum, onSetMaxRoomNum, onSetMinRoomNum } = usePlanMinAndMaxRoomNum();

	const defaultValue = useMemo(() => {
		if (
			maxPeopleNumPerRoom?.isEdited ||
			minimumPeopleNumPerRoom.isEdited ||
			maxRoomNum?.isEdited ||
			minRoomNum?.isEdited
		) {
			return uniqueId;
		}

		return undefined;
	}, [
		maxPeopleNumPerRoom?.isEdited,
		minimumPeopleNumPerRoom.isEdited,
		maxRoomNum?.isEdited,
		minRoomNum?.isEdited,
		uniqueId,
	]);

	return (
		<Accordion type={"single"} collapsible defaultValue={defaultValue}>
			<AccordionItem value={uniqueId}>
				<AccordionTrigger>
					<p>宿泊可能人数・部屋に関する設定(最大数・最小数)</p>
				</AccordionTrigger>

				<AccordionContent>
					<div className="flex flex-col gap-y-8 pb-9">
						<QuestionMinAndMaxPeopleNumPerRoom
							maxPeopleNumPerRoom={maxPeopleNumPerRoom}
							onSetMaxPeopleNumPerRoom={onSetMaxPeopleNumPerRoom}
							minPeopleNumPerRoom={minimumPeopleNumPerRoom}
							onSetMinPeopleNumPerRoom={onSetMinimumPeopleNumPerRoom}
						/>
						<QuestionMinAndMaxNum
							maxRoomNum={maxRoomNum}
							minRoomNum={minRoomNum}
							onSetMaxRoomNum={onSetMaxRoomNum}
							onSetMinRoomNum={onSetMinRoomNum}
						/>
					</div>
				</AccordionContent>
			</AccordionItem>
		</Accordion>
	);
});

QuestionPlanMinAndMaxPeopleNum.displayName = "QuestionPlanMinAndMaxPeopleNum";
